import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {

  isEnglish:boolean = false;

  fontFamily:any;
  textDirection:string = 'rtl';

  baseUrl: string = 'https://api.qlift.co';

  constructor(private http: HttpClient) {
    this.fontFamily = 'Cairo, sans-serif !important';
    this.isEnglish = false;
  }

  stripHtmlTags(htmlString: string): string {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
  }
  getArticles(query:string):Observable<any> {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
        .set('Accept-Language', this.isEnglish?'en':'ar' );

    const requestOptions = {
      headers: headers,
    };

    return this.http.get(
      `${this.baseUrl}/articles?${query}`,
      requestOptions
    ).pipe(catchError(this.handleError));
  }

  getArticle(articleId: string | null):Observable<any>{
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Accept-Language', this.isEnglish?'en':'ar' );

    const requestOptions = {
      headers: headers,
    };

    return this.http.get(
      `${this.baseUrl}/articles/${articleId}`,
      requestOptions
    ).pipe(catchError(this.handleError));
  }

  public handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      return throwError(() => new Error('شيء ما سيء حدث؛ الرجاء معاودة المحاولة في وقت لاحق.'));
    } else {

      return throwError(() => new Error(error.error.message));
    }
  }

  changeLocale(isEnglish:boolean){

    this.isEnglish = isEnglish;

    const fontFamilies = {
      en: 'SF Pro Display, sans-serif !important',
      ar: 'Cairo, sans-serif !important',
    };

    this.fontFamily = fontFamilies[isEnglish?'en':'ar'];
    this.textDirection = isEnglish?'ltr':'rtl';
    document.body.style.fontFamily = this.fontFamily;

  }

}
